<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Reativar cobrança
          </h4>
        </div>
        <div class="modal-body">
          <div class="modal-body">
            <p>Observações</p>
            <input @click="errorMessage = null" class="form-input" type="text" v-model="observations">
          </div>
          <div class="modal-body">
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="reactivateBilling()">
            Reativar a cobrança
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BillingsService from 'services/BillingsService';

export default {
  data() {
    return {
      observations: null,
      errorMessage: null,
    };
  },
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
      'loadStudentBillings',
    ]),
    validate() {
      if (!this.observations) {
        this.errorMessage = 'Preencha todos os campos';
        return false;
      }
      return true;
    },
    reactivateBilling() {
      if (!this.validate()) return;

      this.$loader.show();
      BillingsService.reactivateBilling(this.billing.id, this.observations)
        .then(() => {
          Promise.all([
            this.loadStudentBillings(),
            this.loadStudentBills(),
          ]);
        })
        .then(() => this.$alert.notifySuccess('Cobrança reativada com sucesso'))
        .catch(({ body }) => this.$alert.notifyAlert(`Erro ao reativar a cobrança: ${body.message}`))
        .finally(() => {
          this.$emit('close');
          this.$loader.hide();
        });
    },
  },
};
</script>
